import React, {useState} from "react";
import styled from "@emotion/styled";
import {useTheme} from "@emotion/react";
import CustomLabel from "./CustomLabel";
import {GENDER_NUM_FEMALE, GENDER_NUM_MALE} from "../../../constant/options";

/*
    props
    current_value : "male" | "female"
    on_change : func
 */
const CustomGenderSelect = (props) => {
    // state
    const [active_gender_num, setActiveGenderNum] = useState(
        props.current_value === "male" ? GENDER_NUM_MALE : GENDER_NUM_FEMALE
    );

    // css style
    const {view} = useComponentStyle(active_gender_num);

    return (
        <view.ModifyGenderSection>
            <CustomLabel htmlFor={"gender-wrapper"} label_name={"성별"} />
            <div className="gender-wrapper">
                <view.MaleBox
                    onClick={() => {
                        props.on_change("male");
                        setActiveGenderNum(GENDER_NUM_MALE);
                    }}>
                    남자
                </view.MaleBox>
                <view.FemaleBox
                    onClick={() => {
                        props.on_change("female");
                        setActiveGenderNum(GENDER_NUM_FEMALE);
                    }}>
                    여자
                </view.FemaleBox>
            </div>
        </view.ModifyGenderSection>
    );
};

export default CustomGenderSelect;

export const useComponentStyle = (active_gender_num) => {
    const theme = useTheme();
    return {
        view: {
            ModifyGenderSection: styled.div({
                marginBottom: "1.5em",
                "& .gender-wrapper": {
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: ".5em",
                },
            }),
            MaleBox: styled.div({
                width: "45%",
                height: "2.6em",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: `1px solid ${
                    active_gender_num === GENDER_NUM_MALE ? theme.colors.bearu_primary : theme.colors.lg2
                }`,
                color: active_gender_num === GENDER_NUM_MALE && theme.colors.bearu_primary,
                cursor: "pointer",
            }),
            FemaleBox: styled.div({
                width: "45%",
                height: "2.6em",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: `1px solid ${
                    active_gender_num === GENDER_NUM_FEMALE ? theme.colors.bearu_primary : theme.colors.lg2
                }`,
                color: active_gender_num === GENDER_NUM_FEMALE && theme.colors.bearu_primary,
                cursor: "pointer",
            }),
        },
    };
};
